import { call, put, select, takeEvery, takeLatest } from 'redux-saga/effects';
import {
    deleteFileDataAsyncActions,
    fetchFileDataAsyncActions,
    fetchFileDataByIdAsyncActions,
    ILoadDataForFilesActionSuccessPayload,
    loadDataForFilesAsyncAction,
    saveFileDataAsyncActions,
} from "./actions";
import { api } from "../../../firebase";
import { fileDataCollectionKey } from "../../../firebase/api";
import { IFileData } from "./types";
import { IdObjectsWithId } from "../../../utils";
import { IFile } from "../types";
import { selectFiles, selectFilesData } from "../selectors";
import { loadActiveFoldersAction } from "../../banner/template/files/actions";

function* fetchFileDataByIdSaga(action: ReturnType<typeof fetchFileDataByIdAsyncActions.request>) {
    try {
        const data: IFileData = yield call(api.fetchDocById, fileDataCollectionKey, action.payload.id);

        yield put(fetchFileDataByIdAsyncActions.success({ fileData: data }));
    } catch (e: any) {
        yield put(fetchFileDataByIdAsyncActions.failure({ error: e }));
    }
}

function* loadDataForFilesAsyncSuccessSaga(params: ILoadDataForFilesActionSuccessPayload) {
    yield put(loadDataForFilesAsyncAction.success(params))
}

function* loadDataForFilesAsyncSaga(action: ReturnType<typeof loadDataForFilesAsyncAction.request>) {
    try {
        let ids = action.payload.fileIds
        const allData: IdObjectsWithId<IFileData> = yield select(selectFilesData);
        const allFiles: IdObjectsWithId<IFile> = yield select(selectFiles);

        const dataIds = ids.filter(id => {
            return !allData.byId[id]
        }).reduce((result: string[], id) => {
            const file = allFiles.byId[id]
            if (file && file.fileDataId) {
                result.push(file.fileDataId)
            }
            return result
        }, []);

        const data: IdObjectsWithId<IFileData> = yield call(api.fetchAll, fileDataCollectionKey, dataIds);

        yield call(loadDataForFilesAsyncSuccessSaga, { ids: action.payload.fileIds, filesData: data })

        yield put(loadActiveFoldersAction({}))

    } catch (e: any) {
        yield put(loadDataForFilesAsyncAction.failure({ error: e }))
    }
}


function* fetchFileDataSaga(action: ReturnType<typeof fetchFileDataAsyncActions.request>) {
    try {
        // @ts-ignore
        const data = yield call(api.fetchCollection, fileDataCollectionKey);
        yield put(fetchFileDataAsyncActions.success({ fileDataList: data }));
    } catch (e: any) {
        yield put(fetchFileDataAsyncActions.failure({ error: e }));
    }
}

function* saveFileDataSaga(action: ReturnType<typeof saveFileDataAsyncActions.request>) {
    try {
        // @ts-ignore
        const data = yield call(api.saveDocToCollection, fileDataCollectionKey, action.payload.fileData);
        yield put(saveFileDataAsyncActions.success({ fileData: data }));
    } catch (e: any) {
        yield put(saveFileDataAsyncActions.failure({ error: e }))
    }
}

function* deleteFileDataSaga(action: ReturnType<typeof deleteFileDataAsyncActions.request>) {
    try {
        yield call(api.deleteDocById, fileDataCollectionKey, action.payload.id);
        yield put(deleteFileDataAsyncActions.success({ id: action.payload.id }))
    } catch (e: any) {
        yield put(deleteFileDataAsyncActions.failure({ error: e }))
    }
}

function* fileDataActionWatcher() {
    yield takeEvery(fetchFileDataByIdAsyncActions.request, fetchFileDataByIdSaga)
    yield takeLatest(fetchFileDataAsyncActions.request, fetchFileDataSaga);
    yield takeLatest(saveFileDataAsyncActions.request, saveFileDataSaga);
    yield takeEvery(deleteFileDataAsyncActions.request, deleteFileDataSaga);
    yield takeEvery(loadDataForFilesAsyncAction.request, loadDataForFilesAsyncSaga);
}

export default fileDataActionWatcher;